module.exports = __webpack_public_path__ + "img/mfd_team.23adfab2.png";